"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = fingerprintSub;
function fingerprintSub(name, params) {
    return JSON.stringify({ name: name, params: params });
}


//////////////////
// WEBPACK FOOTER
// ../~/asteroid/lib/common/fingerprint-sub.js
// module id = 317
// module chunks = 7